import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=71e79ce6&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Modal.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/data/vstsagent03/user/3333/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('71e79ce6')) {
      api.createRecord('71e79ce6', component.options)
    } else {
      api.reload('71e79ce6', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=71e79ce6&", function () {
      api.rerender('71e79ce6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/globals/ModalInviteEmployee/Modal.vue"
export default component.exports